import { HotelProduct } from '@/api/Cart/cart.interfaces';
import { getProductPricing } from '@/helpers/price';
import { Money } from '@libs/money/money.interfaces';
import { t } from '@shared/helpers/translation';

export const mapHotelLabel = (product: HotelProduct): string => {
    return product.Description;
};

export const mapHotelSubLabel = (product: HotelProduct): string | undefined => {
    if (product.Rooms) {
        const rooms = product.Rooms.length;
        return `${rooms} ${t({
            key: 'shared.room',
            keyPlural: 'shared.rooms',
            count: rooms,
        })}`;
    }
};

export const mapHotelPrice = (product: HotelProduct): Money => {
    const pricing = getProductPricing(product);
    return {
        Amount: pricing.price.Amount,
        Currency: product.Price.Currency,
    };
};
